module.exports = __webpack_public_path__ + "static/media/align-center.9779c472.svg";